import React from 'react';
import { observer } from 'mobx-react';

import { useCSVDownloader } from 'react-papaparse';

import './styles.css';
import { useStore } from 'utils/hooks/store';
import { UserRole } from 'core/constants';
import { CSVImportColumns } from 'utils/api/types';
import { ImportVocabulary, importTemplateColumns } from 'utils/csv/importVocabulary';

const basicCsvData: Record<string, string> = {
  [CSVImportColumns.firstName]: 'John',
  [CSVImportColumns.lastName]: 'Smith',
  [CSVImportColumns.email]: 'john.smith@organisation.com',
  [CSVImportColumns.role]: 'Account Owner/Manager/User',
  [CSVImportColumns.dateOfBirth]: '01/01/1901',
  [CSVImportColumns.phoneNumber]: '00447761122132',
  [CSVImportColumns.teams]: 'Team 1, Team 2',
  [CSVImportColumns.memorableWord]: 'Word',
  [CSVImportColumns.loneWorkingLicense]: 'FALSE',
  [CSVImportColumns.auditsLicense]: 'FALSE',
  [CSVImportColumns.eventsLicense]: 'FALSE',
  [CSVImportColumns.documentsLicense]: 'FALSE',
  [CSVImportColumns.alarmResponseProfile]: 'ARP 1',
  [CSVImportColumns.costCentre]: 'Centre',
};

const DownloadButton: React.FC<{ vocabulary: ImportVocabulary }> = ({ vocabulary }): React.ReactElement => {
  const { CSVDownloader, Type } = useCSVDownloader();
  const { session } = useStore();

  const row: Record<string, string> = { ...basicCsvData };
  importTemplateColumns(vocabulary).forEach(({ header, example }) => {
    row[header] = example;
  });
  if (session.user?.role === UserRole.Admin) {
    row.Account = '';
  }

  return (
    // CSVDownloader forwards no extra props, so the testid goes on a wrapper.
    <span data-testid="download-template">
      <CSVDownloader className="csvDownloader" type={Type.Link} bom filename="template" delimiter="," data={[row]}>
        Download this template
      </CSVDownloader>
    </span>
  );
};

export default observer(DownloadButton);
